import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {GetEmployeeCostCentersListApiResponse} from '../types';

const getEmployeeCostCentersMock: GetEmployeeCostCentersListApiResponse = {
  costCenters: [
    {
      id: '5fbef3c5-0ec3-4683-9723-261143f40f8e',
      description: 'Hyundai (Praha) | Service',
      branch: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      company: '2d191d67-e985-40e4-9b66-1d327f7a4074',
      isActive: true,
    },
    {
      id: 'c34b2585-dbb6-44ae-97e7-74ef615519d6',
      description: 'Mercedes (Praha) | Service',
      branch: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      company: '2d191d67-e985-40e4-9b66-1d327f7a4074',
      isActive: true,
    },
    {
      id: '30153bb0-0be4-41ab-9d1d-220783d55860',
      description: 'Other (Praha) | Service',
      branch: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
      company: '2d191d67-e985-40e4-9b66-1d327f7a4074',
      isActive: true,
    },
  ],
};

const getEmployeeCostCentersResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/employee-cost-centers*', () =>
      HttpResponse.json(getEmployeeCostCentersMock)
    )
  );

export const metadaCoreEmployeeCostCenterApiMock = {
  getEmployeeCostCentersMock,
  getEmployeeCostCentersResponseInterceptor,
};
